/* eslint-disable camelcase */
import homeConfig from './home.config';
import searchBooksConfig from './search-books.config';
import searchWitnessesConfig from './search-witnesses.config';
import searchBibliografia from './search-bibliography.config';
import searchIconographiesConfig from './search-iconographies.config';
import searchToolsConfig from './search-tools.config';
import searchBiographiesConfig from './search-biographies.config';
import resourceBookConfig from './resource-book.config';
import resourceToponymConfig from './resource-toponym.config';
import resourceIconographyConfig from './resource-iconography.config';
import resourceKeywordConfig from './resource-keyword.config';
import resourceWitnessConfig from './resource-witness.config';
import resourceBiographyConfig from './resource-biography.config';
import resourceModalBibliography_witConfig from './resource-modal-bibliography_wit.config';
import resourceToolConfig from './resource-tool.config';
import searchPersonsConfig from './search-persons.config';
import resourcePersonaConfig from './resource-persona.config';
import searchVoceOnomasticaConfig from './search-voce_onomastica.config';
import resourceVoceOnomasticaConfig from './resource-voce_onomastica.config';
import searchCaricheConfig from './search-cariche.config';
import resourceCaricaConfig from './resource-carica.config';
import searchTerminiConfig from './search-termini.config';
import resourceTermineConfig from './resource-termine.config';
import searchFormuleDatazioneConfig from './search-formule-datazione.config';
import searchLuoghiConfig from './search-luoghi.config';
import resourceLuogoConfig from './resource-luogo.config';
import searchOrganizzazioniConfig from './search-organizzazioni.config';
import resourceOrganizzazioneConfig from './resource-organizzazione.config';
import itineraryConfig from './itinerary.config';
import advancedSearchConfig from './advanced-search.config';
import advancedResultsConfig from './advanced-results.config';

// Graffito
import searchGraffitiConfig from './search-graffiti.config';
import tabsConfig from './tabs.config';
import resourceGraffitoLocalizationConfig from './graffito/resource-graffito-localization.config';
import resourceGraffitoDateConfig from './graffito/resource-graffito-date.config';
import resourceGraffitoDescriptionConfig from './graffito/resource-graffito-description.config';
import resourceGraffitoTextConfig from './graffito/resource-graffito-text.config';
import resourceGraffitoConservationConfig from './graffito/resource-graffito-conservation.config';
import resourceGraffitoBiblioConfig from './graffito/resource-graffito-biblio.config';
import resourceGraffitoObservationConfig from './graffito/resource-graffito-observation.config';
import resourceGraffitoLinksConfig from './graffito/resource-graffito-links.config';

export default {
  home: homeConfig,
  itinerary: itineraryConfig,
  'search-books': searchBooksConfig,
  'search-witnesses': searchWitnessesConfig,
  'resource-biography': resourceBiographyConfig,
  'resource-tool': resourceToolConfig,
  'search-tools': searchToolsConfig,
  'search-biographies': searchBiographiesConfig,
  'resource-iconography': resourceIconographyConfig,
  'search-iconographies': searchIconographiesConfig,
  'resource-witness': resourceWitnessConfig,
  'resource-book': resourceBookConfig,
  'resource-toponym': resourceToponymConfig,
  'resource-keyword': resourceKeywordConfig,
  'search-bibliografia': searchBibliografia,
  'resource-modal-bibliography_wit': resourceModalBibliography_witConfig,
  'search-persons': searchPersonsConfig,
  'resource-persona': resourcePersonaConfig,
  'search-voce_onomastica': searchVoceOnomasticaConfig,
  'resource-voce_onomastica': resourceVoceOnomasticaConfig,
  'search-cariche': searchCaricheConfig,
  'resource-carica': resourceCaricaConfig,
  'search-termini': searchTerminiConfig,
  'resource-termine': resourceTermineConfig,
  'search-formule-datazione': searchFormuleDatazioneConfig,
  'search-luoghi': searchLuoghiConfig,
  'resource-luogo': resourceLuogoConfig,
  'search-organizzazioni': searchOrganizzazioniConfig,
  'resource-organizzazione': resourceOrganizzazioneConfig,
  'advanced-search': advancedSearchConfig,
  'advanced-results': advancedResultsConfig,
  
  // Graffito
  'search-graffiti': searchGraffitiConfig,
  tabs: tabsConfig,
  'resource-graffito-localization': resourceGraffitoLocalizationConfig,
  'resource-graffito-date': resourceGraffitoDateConfig,
  'resource-graffito-description': resourceGraffitoDescriptionConfig,
  'resource-graffito-text': resourceGraffitoTextConfig,
  'resource-graffito-conservation': resourceGraffitoConservationConfig,
  'resource-graffito-biblio': resourceGraffitoBiblioConfig,
  'resource-graffito-observation': resourceGraffitoObservationConfig,
  'resource-graffito-links': resourceGraffitoLinksConfig,
};
